// export const INTEGER_REGEXP = /^[0-9]*$/;
export const INTEGER_REGEXP = /^[0-9]+$/;
// export const NUMBER_REGEXP = /^[0-9]{0,7}\.?([0-9]{1,2})?$/;
// export const NUMBER_REGEXP = /^[0-9]{0,10}$/;
export const NUMBER_REGEXP = /^[0-9]{0,10}(?:\.[0-9]{1,2})?$/;

// export const USERNAME_REGEXP = /^[a-zA-Z0-9]*$/;
export const USERNAME_REGEXP = /^[a-zA-Z][a-zA-Z0-9@#$^&*._-]*$/;
